import DefaultButton from '../General/DefaultButton';
import { globalDirectories } from '../../globalDirectories';

const HeroSection = () => {
  return (
    <section className="bg-gray-900 bg-opacity-0 ext-white py-16 px-6">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-10">
        <div className="flex-1">
          <div className='aspect-[1] w-full max-w-[200px] sm:max-w-[300px] md:max-w-[400px] lg:max-w-[500px]'>
            <img 
            src={globalDirectories.bestModelRender} 
            alt="Best model by Ilja" 
            className="rounded-xl md:mx-0 shadow-lg object-contain relative inset-0 w-full h-full object-cover"
          />
          </div>
        </div>

        <div className="flex-1 text-center md:text-left">
          <h1 className="text-4xl font-bold mb-4">Crafted with Passion</h1>
          <p className="text-lg mb-6">
            Explore a collection of 3D models by Ilja De Bondt – detailed, imaginative, and always evolving.
          </p>
          <DefaultButton to="/gallery">View Gallery</DefaultButton>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;